import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import storage from '../lib/storage';

const ThemeContext = createContext({
  theme: 'dark',
  toggleTheme: () => {}
});

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const nextTheme = 'dark';
    setTheme(nextTheme);
    storage.set('theme', nextTheme);
    document.documentElement.setAttribute('data-theme', nextTheme);
  }, []);

  const toggleTheme = () => {
    const next = 'dark';
    setTheme(next);
    storage.set('theme', next);
    document.documentElement.setAttribute('data-theme', next);
  };

  const value = useMemo(() => ({ theme, toggleTheme }), [theme]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
